import { Output, EventEmitter } from '@angular/core';
import { CurrentUser } from './models/current-user.model';
import { ContainerService } from './services/container.service';
import { Subscription } from 'rxjs/Subscription';
import {StorageService} from './storage.service';

export class AppBase extends StorageService {
  currentUser: CurrentUser = null;
  localeSettings = null;

  currentCommunityName: any;
  currentCommunityImg: any;
  addressCommunity: any;
  localCodeCommunity: any;
  langDataTables: any;
  public dtOptions: DataTables.Settings = {};
  public subscriptionContainer: Subscription;

  public containerLg = false;
  public containerMd = false;
  public containerSm = false;
  public activateOverlay = 'none';


  constructor() {
    super();
    this.initStorage();
  }

  initStorage() {
    this.currentUser = this.getCurrentUser();
    this.localeSettings = this.getLocaleSettings();

    const localCommunityName = localStorage.getItem('currentCommunity');
    const localCommunityImg = localStorage.getItem('imgCommunity');
    this.addressCommunity = localStorage.getItem('addressCommunity');
    this.localCodeCommunity = localStorage.getItem('codeCommunity');
    if (localCommunityName) {
      this.currentCommunityName = localCommunityName;
    }
    if (localCommunityImg) {
      this.currentCommunityImg = localCommunityImg;
    }
  }

  initDataTables() {
    this.langDataTables = JSON.parse(localStorage.getItem('dataTablesLang'));
    this.dtOptions = {
      language: this.langDataTables,
      dom: '<f<t>p>',
    };
  }
}


export class AppContainer extends AppBase {

  @Output()
  public close = new EventEmitter;

  @Output()
  public succes = new EventEmitter;

  constructor(
    public _containerService: ContainerService,
  ) {
    super();
    this.subscriptionContainer = this._containerService.observableStateContainer$
      .subscribe(
        res => {
          this.containerLg = false;
          this.containerMd = false;
          this.containerSm = false;
          if (res === 'large') {
            this.containerLg = !this.containerLg;
            this.containerMd = false;
            this.containerSm = false;
            this.activateOverlay = 'block';
          }
          if (res === 'medium') {
            this.containerMd = !this.containerMd;
            this.containerLg = false;
            this.containerSm = false;
            this.activateOverlay = 'block';
          }
          if (res === 'small') {
            this.containerSm = !this.containerSm;
            this.containerLg = false;
            this.containerMd = false;
            this.activateOverlay = 'block';
          }
        });
    this.activateOverlay = 'none';
  }

  public closeContainer(): void {
    this.containerLg = false;
    this.containerMd = false;
    this.containerSm = false;
    this.activateOverlay = 'none';
    this.close.emit();
  }

  public liftSuperimposedContainer(measure: string): void {
    this._containerService.changeStateContainer(measure);
  }
}



// WEBPACK FOOTER //
// ./src/app/app-base.ts